import React from 'react';
import Lottie from 'react-lottie';
import PropTypes from 'prop-types';
import animationData from '../../LottieAnimations/bouncing_circles.json';
import style from './style.module.scss';

const LottieLoadingView = ({
    size = 400,
    options = {},
}) => {

    const lottieOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
    };

    return (
        <div className={style.wrapper}>
            <Lottie options={{ ...lottieOptions, ...options }}
                height={size}
                width={size}
            />
        </div>
    );
};

LottieLoadingView.propTypes = {
    options: PropTypes.object,
    size: PropTypes.number
};

export default LottieLoadingView;